import React from "react";
import SocialIcon from "./SocialIcon";

const fallbackTitle = (item) => {
  const type = item?.type || "Social";
  if (item?.title && String(item.title).trim()) return item.title;
  if (item?.body && String(item.body).trim()) {
    return String(item.body).trim().slice(0, 80);
  }
  return `${type} post`;
};

const isVideoItem = (item, isVideoUrl) => {
  const typeKey = String(item?.type || "").toLowerCase();
  if (typeKey === "youtube") return true;
  if (item?.media_type === "VIDEO") return true;
  return isVideoUrl?.(item?.media_url);
};

export default function SocialArticleCard({ item, onClick, isVideoUrl }) {
  const typeKey = String(item?.type || "").toLowerCase();
  const iconName = {
    facebook: "facebook",
    instagram: "instagram",
    youtube: "youtube",
  }[typeKey];

  const title = fallbackTitle(item);
  const body = item?.body || "";
  const date = item?.date || "";
  const imageUrl =
    item?.image_url ||
    item?.thumbnail_url ||
    `https://picsum.photos/seed/${item?.seed || "social"}/1200/800`;
  const showVideo = isVideoItem(item, isVideoUrl);

  const [imageLoaded, setImageLoaded] = React.useState(false);

  React.useEffect(() => {
    setImageLoaded(false);
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => setImageLoaded(true);
  }, [imageUrl]);

  return (
    <article
      className={`social_article_card flex flex-col ${!imageLoaded ? "animate-pulse bg-gray-200" : ""}`}
      style={{ "--social-card-image": imageLoaded ? `url(${imageUrl})` : "none" }}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="social_article_card__media" />
      <div className="social_article_card__overlay" />

      {iconName ? (
        <div className="social_article_card__icon" aria-hidden>
          <SocialIcon name={iconName} size="md" />
        </div>
      ) : null}

      {showVideo ? (
        <div className="social_article_card__play" aria-hidden>
          <div className="social_article_card__play-inner">
            <span className="material-icons">play_arrow</span>
          </div>
        </div>
      ) : null}

      <div className="social_article_card__content flex flex-col justify-end">
        <div className="social_article_card__meta t-caption">{date}</div>
        <h3 className="social_article_card__title t-h4">{title}</h3>
        <p className="social_article_card__body t-body">{body}</p>
      </div>
    </article>
  );
}
